import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { checkSharedLiquidity, useSAGGameUrl, useSAGHandleRegisterOpened } from '@swf/poker';

import { type Game, GameType, type GameTypeName } from '../../../../types/Game';
import Tile from '../../../Tiles/Tile';

import { TXTCLI_Play_Now, TXTWCL_Login_to_Play } from './HighestValueGame.messages.json';
import styles from './HighestValueGame.scss';

interface Props {
  gameType: GameTypeName;
  game: Game;
  isSharedLiquidityEnabled?: boolean;
  widgetId?: string;
}

const gameTypeClassNames = {
  Holdem: 'holdem',
  HoldemFlash: 'holdemFlash',
  HoldemMax: 'holdemMax',
  HoldemSix: 'holdemSix',
  Omaha: 'omaha'
};

const HighestValueGame = ({ gameType, game, isSharedLiquidityEnabled, widgetId }: Props) => {
  const assetClassName = gameTypeClassNames[gameType];
  const isEmbedded = useSelector(select.device.isEmbedded);
  const site = useSelector(select.cms.getSiteId);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const isEnabled = checkSharedLiquidity(!!isSharedLiquidityEnabled, game.tournSites, site);
  const formattedGame = {
    ...game,
    isEnabled
  };
  const tableUrl = useSAGGameUrl({
    isFlash: formattedGame.isFlash && gameType === GameType.HoldemFlash,
    isMax: formattedGame.isMax,
    scriptId: formattedGame.scriptId
  });
  const tileScriptId = formattedGame.scriptId;

  const handleRegisterOpened = useSAGHandleRegisterOpened({
    tableUrl,
    tileScriptId,
    shouldCloseOldModalFirst: true,
    isFlash: gameType === GameType.HoldemFlash
  });

  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.dynamicContainer,
          styles[assetClassName as keyof typeof styles]
        )}
      >
        <Tile
          className={styles.customTile}
          classNameInner={styles.customTileInner}
          tile={formattedGame}
          gameType={gameType}
          isActive
          widgetId={widgetId}
        />
        <StarsButton
          variant="primary"
          size="large"
          disabled={!isEnabled}
          onClick={handleRegisterOpened}
          translation={isAuthenticated || isEmbedded ? TXTCLI_Play_Now : TXTWCL_Login_to_Play}
        />
      </div>
    </div>
  );
};

export default HighestValueGame;
